import type { PropsWithChildren } from 'react';

import { TrialProvider as SharedTrialProvider } from '@cast/shared-trial-ui';
import type { TrialState } from '@cast/shared-trial-ui';

import {
  createBooleanOverride,
  createDropdownOverride,
} from 'core/dev-toolbox';

// Registers reporting-trial Dev Toolbox overrides at module load.
import './configureReportingTrialDevOverrides';

const useTrialStateOverride = createDropdownOverride<TrialState>(
  'trialState',
  ['pre-trial', 'active', 'grace-period', 'post-trial'],
  { group: 'trial' }
);

const useIsEligibleOverride = createBooleanOverride('isEligible', {
  group: 'trial',
});

export const TrialProvider = ({ children }: PropsWithChildren) => (
  <SharedTrialProvider
    devOverrides={{ useTrialStateOverride, useIsEligibleOverride }}
  >
    {children}
  </SharedTrialProvider>
);
